"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var skynet_actions_subject_service_1 = require("./store/skynet-actions-subject.service");
var skynet_reducer_manager_service_1 = require("./store/skynet-reducer-manager.service");
var skynet_scanned_actions_subject_service_1 = require("./store/skynet-scanned-actions-subject.service");
var skynet_state_service_1 = require("./store/skynet-state.service");
var skynet_store_service_1 = require("./store/skynet-store.service");
var SkynetStoreRootModule = /** @class */ (function () {
    function SkynetStoreRootModule() {
    }
    SkynetStoreRootModule.forRoot = function () {
        return {
            ngModule: store_1.StoreRootModule,
            providers: [
                { provide: store_1._INITIAL_STATE, useValue: undefined },
                {
                    provide: store_1.INITIAL_STATE,
                    useExisting: store_1._INITIAL_STATE,
                },
                { provide: store_1._INITIAL_REDUCERS, useValue: {} },
                {
                    provide: store_1._STORE_REDUCERS,
                    useExisting: store_1._INITIAL_REDUCERS,
                },
                {
                    provide: store_1.INITIAL_REDUCERS,
                    useExisting: store_1._INITIAL_REDUCERS,
                },
                {
                    provide: store_1.META_REDUCERS,
                    useValue: [],
                },
                {
                    provide: store_1._REDUCER_FACTORY,
                    useValue: store_1.combineReducers,
                },
                {
                    provide: store_1.REDUCER_FACTORY,
                    deps: [store_1._REDUCER_FACTORY, store_1.META_REDUCERS],
                    useFactory: store_1.createReducerFactory,
                },
                {
                    provide: store_1.ActionsSubject,
                    useFactory: skynet_actions_subject_service_1.skynetActionsSubjectFactory,
                },
                {
                    provide: store_1.ReducerManager,
                    useFactory: skynet_reducer_manager_service_1.skynetReducerManagerFactory,
                    deps: [
                        store_1.ReducerManagerDispatcher,
                        store_1.INITIAL_STATE,
                        store_1.INITIAL_REDUCERS,
                        store_1.REDUCER_FACTORY,
                    ],
                },
                {
                    provide: store_1.Store,
                    useFactory: skynet_store_service_1.skynetStoreFactory,
                    deps: [store_1.StateObservable, store_1.ActionsSubject, store_1.ReducerManager],
                },
                {
                    provide: store_1.State,
                    useFactory: skynet_state_service_1.skynetStateFactory,
                    deps: [
                        store_1.ActionsSubject,
                        store_1.ReducerObservable,
                        store_1.ScannedActionsSubject,
                        store_1.INITIAL_STATE,
                    ],
                },
                {
                    provide: store_1.ScannedActionsSubject,
                    useFactory: skynet_scanned_actions_subject_service_1.skynetScannedActionsSubjectFactory,
                },
                { provide: store_1.ReducerObservable, useExisting: store_1.ReducerManager },
                {
                    provide: store_1.ReducerManagerDispatcher,
                    useExisting: store_1.ActionsSubject,
                },
                { provide: store_1.StateObservable, useExisting: store_1.State },
            ],
        };
    };
    SkynetStoreRootModule = __decorate([
        core_1.NgModule({})
    ], SkynetStoreRootModule);
    return SkynetStoreRootModule;
}());
exports.SkynetStoreRootModule = SkynetStoreRootModule;
//# sourceMappingURL=skynet-store-root.module.js.map